import { matchPath } from "react-router-dom";

import { PUBLIC_PATHS } from "./publicRoutes";

/**
 * Docusign signing callback pages render inside the signing modal's iframe and
 * must load even when the user is authenticated. The public-route guard uses
 * this to skip its authed → dashboard redirect for those paths; without it the
 * iframe shows the dashboard instead of the signing result.
 *
 * Covers the legacy callback (exact path) and the per-property callback
 * (parameterized, so matched by pattern rather than equality).
 */
export const isSigningCallbackPath = (pathname: string): boolean =>
  pathname === PUBLIC_PATHS.DOCUMENT_SIGNING_REDIRECT ||
  matchPath(
    { path: PUBLIC_PATHS.PROPERTY_DOCUSIGN_CALLBACK, end: true },
    pathname
  ) !== null;
